import styled from "styled-components/macro";
import media from "../../constants/MediaQuery";
import { DPIconCircleRightArrow } from "../../assets/icons";
import Button from "../../atoms/Button";
import Typography from "../../atoms/typography";
import { useState } from "react";
import Modal from "../../atoms/Modal";
import { BecomeAnAgentForm } from "../../atoms/BecomeAnAgentForm";
import Theme from "constants/Theme";
import { motion } from "framer-motion";

const container = {
  hidden: { opacity: 0, y: "100px", scale: 0.9 },
  show: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 1,
      delayChildren: 0.5,
      delay: 0.5,
    },
  },
};

const item = {
  hidden: { opacity: 0, y: "100px" },
  show: { opacity: 1, y: 0 },
};

const Hero = () => {
  const [showAggregatorForm, setShowAggregatorForm] = useState(false);

  return (
    <HPS>
      <Modal
        width="max-content"
        showModal={showAggregatorForm}
        onBackdropClick={() => setShowAggregatorForm(!showAggregatorForm)}
        onCloseClick={() => setShowAggregatorForm(!showAggregatorForm)}
        maxModal
      >
        <BecomeAnAgentForm closeModal={setShowAggregatorForm} />
      </Modal>
      <div className="c">
        <div
          className="Hero__HPS__background-image"
          style={{
            backgroundImage: "url('/assets/images/line.svg')",
            width: "100%",
            margin: "0 auto",
          }}
        />
      </div>
      {/*<img src="/assets/images/line.svg" alt="" />*/}
      <div className="hero-container container">
        <motion.div
          variants={container}
          initial="hidden"
          animate="show"
          // initial={{ x: 0 }}
          className="Hero__HPS--ad-content"
        >
          <img
            // variants={item}
            className="Hero__HPS--ad-content--POS-image"
            src="./assets/images/POS.png"
            alt="POS"
          />
          <motion.div
            variants={item}
            // transition={{ delay: 0.5, stiffness: 70, delayChildren: 0.5 }}
            className="Hero__HPS--ad-content--signup-agent"
          >
            <Typography.Heading
              color="darkBlue"
              fontType="Galano"
              weight="medium"
              level={1}
              className="landing__heading"
              style={{
                fontSize: Theme.fontSizes.xextralarge,
                lineHeight: "116%",
              }}
            >
              Join the team that makes money easily accessible.
            </Typography.Heading>
            <Typography.Text
              level="xlarge"
              color="black"
              weight="medium"
              fontType="Galano"
            >
              Register now to be a change Agent
            </Typography.Text>
            <a href="https://app.dotpay.africa/signup">
              <Button className="landing-btn landing__btn" primary>
                <Typography.Text weight="semiBold" level="xlarge">
                  Become an agent
                </Typography.Text>
                <DPIconCircleRightArrow />
              </Button>
            </a>
          </motion.div>
        </motion.div>
      </div>
    </HPS>
  );
};
const HPS = styled.section`
  position: relative;
  .c {
    position: absolute;
    width: 100%;
    //height: 100%;
    z-index: -1;
  }
  .hero-contaier {
    display: flex;
    justify-content: center;
    align-items: center;
    //padding: 200px 0;
    //background: orange;
  }
  .Hero__HPS {
    position: relative;

    //&__background-image {
    //  position: absolute;
    //  width: 100%;
    //  overflow: hidden;
    //  background: #e4ffe1;
    //  z-index: -1;
    //  height: 465px;
    //
    //  > img {
    //    object-fit: cover;
    //    height: 100%;
    //    max-height: 550px;
    //  }
    //}

    &__background-image {
      //position: absolute;
      // width: 100%;
      //max-height: 550px;
      // background-size: cover;
      //  background: cyan;
      background-repeat: no-repeat;
      background-color: #e4ffe1;
      //   //z-index: -1;
      background-position: right;
      //background-size: cover;
      background-size: 130vw 687px;
      //height: 100vh;
      width: 100%;
      height: 60vh;
    }

    &--ad-content {
      display: flex;
      align-items: center;
      justify-content: center;

      &--POS-image {
        width: 100%;
        max-width: 410px;
        display: none;
      }

      &--signup-agent {
        display: flex;
        flex-direction: column;
        justify-content: center;
        max-width: 498px;
        min-height: 466px;

        .landing-btn {
          margin-bottom: 50px;
        }
      }
    }

    ${media.tabletMin`
      &__background-image {
        height: 65vh;
        background-position: top;
      }
      &--ad-content {
        &--POS-image {
          display: block
        }
        &--signup-agent {
          .landing-btn {
            margin-bottom: unset;
          }
        }
      }
    `}
  }
`;

export default Hero;
